<script lang="ts">
  import type { InputType } from '$lib/types/components';
  import type { HTMLButtonAttributes } from 'svelte/elements';
  import Button from '../Button.svelte';
  import Input from './Input.svelte';

  export let placeholder: string;
  export let buttonText: string = 'Submit';
  export let buttonType: HTMLButtonAttributes['type'] = 'submit';
  export let inputType: InputType = 'text';
  export let value: any = undefined;

  const { class: restPropsClass, ...restProps } = $$restProps;
</script>

<Input {placeholder} type={inputType} size="lg" class={restPropsClass} {...restProps} bind:value>
  <Button slot="right" type={buttonType} class="mb-1 ml-auto mr-1 mt-1">{buttonText}</Button>
</Input>

<!--
@component
Inpit with button attached. Use within a form element.
## Props
@prop value: any = undefined;
@prop placeholder: string;
@prop buttonText: string = 'Submit';
@prop buttonType: HTMLButtonAttributes['type'] = 'submit';
@prop buttonType: InputType = 'text';
-->
